import { Editor, Node, Path } from 'slate';

export const getNodeParent = (editor: Editor, path: Path) => {
    try {
        return Node.parent(editor, path);
    } catch {
        return undefined;
    }
};
